import { useState, useRef, useEffect } from 'react';

import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Avatar, Box, ButtonBase,Divider,  ListItemButton,  ListItemIcon,  ListItemText,  Stack,  Typography } from '@mui/material';

// third-party
import PerfectScrollbar from 'react-perfect-scrollbar';

// project imports
import MainCard from 'ui-component/cards/MainCard';
// project imports
import LogoSection from '../LogoSection';
import ProfileSection from './ProfileSection';
import NotificationSection from './NotificationSection';

// assets
import { IconLogout,IconMenu2 } from '@tabler/icons';

import authClass from '../../../utils/authclass'
// ==============================|| MAIN NAVBAR / HEADER ||============================== //

const Header = ({ handleLeftDrawerToggle }) => {
  const usersData = useSelector( (state) => state.session)
  const theme = useTheme();
  const customization = useSelector((state) => state.customization);
  const navigate = useNavigate();

  const [sdm, setSdm] = useState(true);
  const [value, setValue] = useState('');
  const [notification, setNotification] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const [open, setOpen] = useState(false);
  /**
   * anchorRef is used on different componets and specifying one type leads to other components throwing an error
   * */
  const anchorRef = useRef(null);
  const handleLogout = async () => {
    authClass.removeUserSession()
    navigate('/login')
  };


  return (
    <>
      {/* logo & toggler button */}
      <Box
        sx={{
          width: 228,
          display: 'flex',
          [theme.breakpoints.down('md')]: {
            width: 'auto'
          }
        }}
      >
        <Box component="span" sx={{ display: { xs: 'none', md: 'block' }, flexGrow: 1 }}>
          <LogoSection />
        </Box>
        <ButtonBase sx={{ borderRadius: '12px', overflow: 'hidden' }}>
          <Avatar
            variant="rounded"
            sx={{
              ...theme.typography.commonAvatar,
              ...theme.typography.mediumAvatar,
              transition: 'all .2s ease-in-out',
              background: theme.palette.secondary.light,
              color: theme.palette.secondary.dark,
              '&:hover': {
                background: theme.palette.secondary.dark,
                color: theme.palette.secondary.light
              }
            }}
            onClick={handleLeftDrawerToggle}
            color="inherit"
          >
            <IconMenu2 stroke={1.5} size="1.3rem" />
          </Avatar>
        </ButtonBase>
      </Box>

      {/* header search */}
     {/* <SearchSection />*/}
      <Box sx={{ flexGrow: 1 }} />
      <Box sx={{ flexGrow: 1 }} />
{/******Logout button******/}
    {/**  <Box sx={{p: 2 ,
              marginTop: '-10px !important',
            }}
            >
        <Stack>
          <Stack direction="row" spacing={2} alignItems="center">
            <Typography component="span" variant="h4" sx={{ fontWeight: 400 }}>
              {usersData?.profile?.user?.firstName.charAt(0).toUpperCase() + usersData?.profile?.user?.firstName.slice(1)+' '+usersData?.profile?.user?.lastName.charAt(0).toUpperCase() +usersData?.profile?.user?.lastName.slice(1)}
            </Typography>

            <a href="" style={{textDecoration: "none",display: "inline-flex"}}selected={selectedIndex === 4} onClick={handleLogout} >
                <IconLogout stroke={1.5} size="1.3rem"  sx={{cursor: 'pointer'}}/> Logout</a>

          </Stack>                      
        </Stack>                    
      </Box>
      <Divider /> */}     
      <ProfileSection />
    </>
  );
};

Header.propTypes = {
  handleLeftDrawerToggle: PropTypes.func
};

export default Header;
